export default "__VITE_ASSET__9e8893ed__"